import { GET_CONFIGURATION } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { fetchConfigurationFailure, fetchConfigurationSuccess} from "./reducer";

export const fetchConfigurations = (setLoading,name) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${GET_CONFIGURATION}?name=${name}`,'GET')
        setLoading(false)
        dispatch(fetchConfigurationSuccess(response))
    }
    catch (error) {
        setLoading(false)
        dispatch(fetchConfigurationFailure(error.message))
    }
}